module.exports = __webpack_public_path__ + "static/media/brandemi.e1c74fea.png";